






































import Vue from 'vue';
import { NavStepState } from '../../lib/enums/navStepState';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'NavStepIcon',

  props: {
    name: { type: String, required: true },
    icon: { type: String },
    altText: { type: String, required: true },
    state: { type: Number, required: true },
    hasArm: { type: Boolean, required: true },
    nextStepState: { type: Number, required: true }
  },

  data() {
    return {
      NavStepState
    };
  },

  methods: {
    clicked() {
      if (
        this.state !== NavStepState.Disabled &&
        this.currentStep >= this.altText
      )
        this.$emit('input', this.name);
      return;
    }
  },

  computed: {
    ...mapState('components/contact-upload-navigation', ['currentStep']),

    buttonStepClass() {
      if (this.isCurrentStep) return 'current-step';
      else if (this.altText < this.currentStep) return 'before-current-step';
      else if (this.altText > this.currentStep) return 'after-current-step';
    },

    isCurrentStep() {
      return this.currentStep === parseInt(this.altText);
    },

    isDisabled() {
      return this.state === NavStepState.Disabled;
    },

    iconDisplay() {
      return this.state === NavStepState.Complete && !this.isCurrentStep
        ? 'mdi-check'
        : this.icon || this.altText;
    },

    iconColor() {
      if (this.isCurrentStep || this.state === NavStepState.Enabled)
        return 'primary';
      else if (this.state === NavStepState.Complete) return '#48c892';
      else return '';
    }
  }
});
